import OrderActionTypes from './action-types';

const initialState = {
	data: [],
	matchLocation: [],
	columns: [
  {
    "label": "SITUAÇÃO",
    "property": "expectedReadinessDate",
    "index": 0,
    "visible": true,
    "visibleOnImport": false
  },
  {
    "label": "PEDIDO",
    "property": "orderDoc",
    "index": 1,
    "visible": true,
    "visibleOnImport": true
  },
  {
    "label": "ITEM",
    "property": "orderLine",
    "index": 2,
    "visible": true,
    "visibleOnImport": true
  },
  {
    "label": "CÓDIGO ERP",
    "property": "erpCode",
    "index": 3,
    "visible": false,
    "visibleOnImport": false
  },
  {
    "label": "CÓDIGO DO PRODUTO",
    "property": "customerProduct?.ean || item?.orderItemExternalId",
    "index": 4,
    "visible": true,
    "visibleOnImport": true
  },
  {
    "label": "DESCRIÇÃO",
    "property": "description",
    "index": 5,
    "visible": false,
    "visibleOnImport": false
  },
  {
    "label": "IMO",
    "property": "Imo",
    "index": 6,
    "visible": false,
    "visibleOnImport": false
  },
  {
    "label": "NCM",
    "property": "ncm",
    "index": 7,
    "visible": true,
    "visibleOnImport": true
  },
 {
    "label": "QUANTIDADE DO PEDIDO",
    "property": "poQty",
    "index": 8,
    "visible": true,
    "visibleOnImport": true
  },
  {
    "label": "QUANTIDADE DISPONÍVEL",
    "property": "quantity",
    "renderQuantity": true,
    "index": 9,
    "visible": true,
    "visibleOnImport": true
  },
  {
    "label": "QUANTIDADE EMBARCADO",
    "property": "quantityShipped",
    "index": 10,
    "visible": true,
    "visibleOnImport": true
  },
  {
    "label": "VALOR UNITÁRIO",
    "property": "valueUnitCalculated",
    "property2": "currency",
    "index": 11,
    "visible": true,
    "visibleOnImport": true
  },
  {
    "label": "VALOR TOTAL",
    "property": "valueAmountCalculated",
    "property2": "currency",
    "index": 12,
    "visible": true,
    "visibleOnImport": true
  },
  {
    "label": "INCOTERM",
    "property": "incoterm?.code",
    "index": 13,
    "visible": true,
    "visibleOnImport": true
  },
  {
    "label": "FORNECEDOR",
    "property": "customerSupplier?.supplierCode",
    "index": 14,
    "visible": true,
    "visibleOnImport": false
  },
  {
    "label": "FABRICANTE",
    "property": "customerManufacturer?.name",
    "index": 15,
    "visible": true,
    "visibleOnImport": true
  },
  {
    "label": "PRONTIDÃO DE CARGA",
    "property": "cargoReadinessDate",
    "index": 16,
    "visible": false,
    "visibleOnImport": false
  },
  {
    "label": "DATA DE LIBERAÇÃO PEDIDO",
    "property": "orderReleaseDate",
    "index": 17,
    "visible": false,
    "visibleOnImport": false
  },
  {
    "label": "PRAZO FORNECEDOR",
    "property": "supplierDeadline",
    "index": 18,
    "visible": true,
    "visibleOnImport": true
  },
  {
    "label": "DATA INÍCIO DE PRODUÇÃO",
    "property": "initialReadinessDate",
    "index": 19,
    "visible": true,
    "visibleOnImport": true
  },
  {
    "label": "DATA ESTIMADA DE PRONTIDÃO",
    "property": "expectedReadinessDate",
    "index": 20,
    "visible": true,
    "visibleOnImport": true
  },
  {
    "label": "DATA EFETIVA DE PRONTIDÃO",
    "property": "actualReadinessDate",
    "index": 20,
    "visible": true,
    "visibleOnImport": true
  },
  {
    "label": "PAÍS DE ORIGEM",
    "property": "originCountry",
    "index": 21,
    "visible": true,
    "visibleOnImport": true
  },
  {
    "label": "DATA DE CRIAÇÃO",
    "property": "createdAt",
    "index": 22,
    "visible": true,
    "visibleOnImport": true
  },
  {
    "label": "PRODUTO",
    "property": "customerProduct?.productName || item?.orderItemExternalId",
    "index": 23,
    "visible": false,
    "visibleOnImport": true,
		"required": true
  },
  {
    "label": "CÓDIGO ERP PRODUTO",
    "property": "erpCodeProduct",
    "index": 24,
    "visible": false,
    "visibleOnImport": true,
		"required": true
  },
  {
    "label": "NOME FORNECEDOR",
    "property": "customerSupplierName",
    "index": 25,
    "visible": false,
    "visibleOnImport": true,
		"required": false
  },
	{
    "label": "CÓDIGO FORNECEDOR",
    "property": "customerSupplierCode",
    "index": 26,
    "visible": false,
    "visibleOnImport": true,
		"required": false
  },
	{
    "label": "TIPO DO FORNECEDOR",
    "property": "customerSupplierType",
    "index": 27,
    "visible": false,
    "visibleOnImport": true,
		"required": false
  },
  {
    "label": "EMAIL DO FORNECEDOR",
    "property": "customerSupplierMail",
    "index": 28,
    "visible": false,
    "visibleOnImport": true,
		"required": false
  },
  {
    "label": "PAÍS DO FORNECEDOR",
    "property": "customerSupplierCountry",
    "index": 29,
    "visible": false,
    "visibleOnImport": true,
		"required": false
  },
  {
    "label": "UNIDADE",
    "property": "unit",
    "index": 30,
    "visible": true,
    "visibleOnImport": true
  },
  {
    "label": "CÓDIGO ERP FABRICANTE",
    "property": "erpCodeManufacturer",
    "index": 31,
    "visible": true,
    "visibleOnImport": true
  },
  {
    "label": "DATA DE NECESSIDADE",
    "property": "needDate",
    "index": 32,
    "visible": true,
    "visibleOnImport": true
  },
  {
    "label": "PO Qty",
    "property": "poQty",
    "index": 99,
    "visible": true,
    "visibleOnImport": false
  }
],
	currentStep: 1,
	loading: false,
};

const userReducer = (state = initialState, action) => {
	switch (action.type) {
		case OrderActionTypes.LOAD_COLUMNS:

      const newColumns = action.payload
        .map(col => ({
          ...col,
          label: col?.label?.toUpperCase()
        }))
        .filter(col => !state.columns.some(existing => existing.property === col.property));

			return {
				...state,
				columns: [...newColumns, ...state.columns]
			};
		case OrderActionTypes.LOAD_FILE_IMPORT:
			return {
				...state,
				data: action.payload,
			};
		case OrderActionTypes.NEXT_STEP:
			return {
				...state,
				currentStep: state.currentStep + 1,
			};
		case OrderActionTypes.PREV_STEP:
			return {
				...state,
				currentStep: state.currentStep - 1,
			};
		case OrderActionTypes.CANCEL_IMPORT:
			return {
				...initialState,
				columns: state?.columns,
			};
		case OrderActionTypes.LOADING:
			return {
				...state,
				loading: action.payload,
			};
		default:
			return state;
	}
};

export default userReducer;
